/**
 * "Preferencje cookies" link in the footer.
 *
 * Reopens Shopify's own consent banner so a visitor can change the choice
 * they made on their first visit. Shopify exposes two APIs depending on how
 * the banner was loaded, so both are tried before falling back to loading the
 * consent API on demand.
 */
(function () {
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cookie-preferences]');
    if (!trigger) return;
    event.preventDefault();

    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
      return;
    }

    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.showPreferences === 'function') {
      privacy.showPreferences();
      return;
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) return;
        var loaded = window.Shopify.customerPrivacy;
        if (loaded && typeof loaded.showPreferences === 'function') loaded.showPreferences();
      });
    }
  });
})();
